module.exports = __webpack_public_path__ + "img/recruiter.c72394f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/recruiter.png
// module id = mok+
// module chunks = 1